/**
 * Modos de respuesta (M-1/M-2, 14-10-2026): Quick answer por defecto y Think deeper.
 * Reemplazan Concisa / Memo / Didáctica. La elección se recuerda en localStorage; la clave vieja
 * (`alertai_profundidad`) se traduce una sola vez: concisa → quick; memo y didáctica → deeper.
 */
export type Modo = 'quick' | 'deeper';

export const MODO_STORAGE_KEY = 'alertai_modo';
export const LEGACY_PROFUNDIDAD_KEY = 'alertai_profundidad';

export const MODOS: { value: Modo; label: string; help: string }[] = [
  { value: 'quick', label: 'Quick answer', help: 'Respuesta corta y directa: la regla y su salvedad principal.' },
  { value: 'deeper', label: 'Think deeper', help: 'Respuesta completa: fundamento, criterio del SII, excepciones y casos relacionados.' },
];

export const modoLabel = (modo: Modo): string => (modo === 'deeper' ? 'Think deeper' : 'Quick answer');

function legacyToModo(value: string | null): Modo | null {
  if (value === 'concisa') return 'quick';
  if (value === 'memo' || value === 'didactica') return 'deeper';
  return null;
}

export function loadStoredModo(): Modo {
  try {
    const stored = localStorage.getItem(MODO_STORAGE_KEY);
    if (stored === 'quick' || stored === 'deeper') return stored;
    const migrated = legacyToModo(localStorage.getItem(LEGACY_PROFUNDIDAD_KEY));
    if (migrated) {
      localStorage.setItem(MODO_STORAGE_KEY, migrated);
      localStorage.removeItem(LEGACY_PROFUNDIDAD_KEY);
      return migrated;
    }
  } catch {
    // localStorage no disponible (navegación privada): vale el modo por defecto
  }
  return 'quick';
}

export function storeModo(modo: Modo): void {
  try {
    localStorage.setItem(MODO_STORAGE_KEY, modo);
  } catch {
    // la elección vale para esta sesión
  }
}

/** Línea al terminar el turno: «Quick answer · 3 fuentes · 6 s». */
export function buildModoReceipt(modo: Modo, citations: { document_id: string }[], elapsedSec: number): string {
  const n = new Set(citations.map(c => c.document_id)).size;
  const fuentes = n === 0 ? 'sin fuentes' : `${n} ${n === 1 ? 'fuente' : 'fuentes'}`;
  return `${modoLabel(modo)} · ${fuentes} · ${Math.max(1, Math.round(elapsedSec))} s`;
}
